'use client';
import React, { useEffect, useState } from 'react';
import { MapPin } from 'lucide-react';
import Card from './card';

function useIsMobile(breakpoint = 640) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

const TheSite = () => {
  const isMobile = useIsMobile();

  return (
    <section
      id="site"
      className="relative w-full bg-cover bg-center flex items-center"
      style={{
        backgroundImage: isMobile
          ? "url('/thesitemobile.png')"
          : "url('/thissite.png')",
        height: isMobile ? '70vh' : undefined
      }}
    >
      <div className="absolute bottom-0 left-0 right-0 h-1/8 bg-gradient-to-t from-[#004746]/100 to-transparent"></div>
      <div className="relative w-full h-full xl:mx-6 mt-0 md:mt-16">
      <div className="px-4 md:px-18 mt-10 md:mt-0">
        <hr style={{ borderColor: '#CDE4E4', borderWidth: '1px'}} className='mb-[10px] md:mb-[40px]' />
      </div>
        <div className="flex flex-col lg:flex-row h-full gap-8 lg:gap-0">
          <div className="w-full lg:w-1/2 text-white flex flex-col justify-start items-start text-left pl-4 pt-2 sm:pt-16 lg:items-start lg:justify-start lg:text-left lg:pl-18 lg:pt-0 md:-mt-6"
            style={{
            }}>
            <h1 id="intro-heading" className="text-6xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold leading-tight">
              THE SITE
            </h1>
            <div className="flex items-center justify-start gap-2 text-2xl sm:text-lg lg:text-xl">
              <MapPin className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6" />
              <span>Peterborough</span>
            </div>
          </div>
          <div className="w-full lg:w-1/2 flex items-center justify-center lg:justify-end px-4 sm:px-6 md:px-8 lg:px-0 lg:pr-18 pb-20 lg:pb-0">
           
            { !isMobile && <Card/> }
          </div>
        </div>
      </div>
    </section>
  );
};

export default TheSite;

<style jsx>{`
  .the-site-bg {
    background-image: url('/thissite.png');
  }
  @media (max-width: 640px) {
    .the-site-bg {
      background-image: url('/thesitemobile.png');
    }
  }
`}</style>